import React from 'react';
import { DashboardCard } from './DashboardCard';

interface RecentEntity {
  id?: number;
  attributes?: Record<string, any>;
}

interface RecentEntityCardProps {
  title: string;
  entityType: string;
  entities: RecentEntity[];
  loading: boolean;
  renderName?: (entity: RecentEntity) => React.ReactNode;
  renderStatus?: (entity: RecentEntity) => React.ReactNode;
  onViewAll: () => void;
  onEntityClick: (id: number | undefined) => void;
}

export const RecentEntityCard: React.FC<RecentEntityCardProps> = ({
  title,
  entityType,
  entities,
  loading,
  renderName,
  renderStatus,
  onViewAll,
  onEntityClick,
}) => {
  const defaultName = (e: RecentEntity) => e.attributes?.name ?? '–';

  return (
    <DashboardCard title={title} onViewAll={onViewAll}>
      {loading ? (
        <div className="dashboard-recent-card-empty">Loading...</div>
      ) : entities.length === 0 ? (
        <div className="dashboard-recent-card-empty">No {entityType}s</div>
      ) : entities.map((entity) => (
        <div
          key={entity.id}
          className="dashboard-recent-card-row"
          onClick={() => onEntityClick(entity.id)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') onEntityClick(entity.id);
          }}
        >
          <span className="dashboard-recent-card-id">#{entity.id}</span>
          <span className="dashboard-recent-card-name">
            {renderName ? renderName(entity) : defaultName(entity)}
          </span>
          <span className="dashboard-recent-card-status">
            {renderStatus ? renderStatus(entity) : '–'}
          </span>
        </div>
      ))}
    </DashboardCard>
  );
};
